/**
 * Render any ERP scalar the same way everywhere it's confirmed — the
 * write dialog and the ledger card both show the user a value they're
 * about to overwrite, and a diverging formatter between them would be its
 * own kind of drift.
 *
 * Deliberately total rather than `String(value)`: these values cross the
 * ERP/MDM boundary as `unknown`, and an object would stringify to
 * "[object Object]" in the one place the user is being asked to confirm
 * what they're overwriting. Every writable ERP field is a scalar by
 * construction (the write catalog only admits text/number/boolean
 * columns), so the object branch is unreachable rather than a real
 * formatting case — render it inertly instead of leaking internals.
 */
export function displayErpValue(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') return String(value);
  if (typeof value === 'string') return value;
  return '—';
}
